import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

// components
import { ListWrap, Navbar, Sidebar, NewNavbar } from "src/components";

import styles from "./styles.module.scss";

// data
import mockup from "src/utils/data";

// api
import { getMyEvents } from "../api";

// context
import UserContext from "src/context/User";

// assets
import { Plus } from "src/assets/icons";

const cx = classNames.bind(styles);

const Content = () => {
  // const [eventList, setEventList] = useState(mockup.empty_3);
  const [eventList, setEventList] = useState(null);
  const [isShow, setIsShow] = useState(false);

  const { user } = useContext(UserContext);

  // useEffect(() => {
  //   if (user) {
  //     let props = {
  //       userId: user.userId,
  //       accessToken: user.accessToken,
  //     };

  //     getMyEvents(props)
  //       .then((res) => {
  //         if (res.data.Status) {
  //           setEventList(res.data.Results);
  //         } else {
  //           setEventList(null);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // }, [user]);

  return (
    <div>
      {/* <Navbar isSidebar setIsShow={setIsShow} /> */}
      <NewNavbar />
      {/* <Sidebar showSidebar={isShow} setShowSidebar={setIsShow} /> */}
      <div className={cx("my-event-root")}>
        {eventList ? (
          <ListWrap heading="My Events" items={eventList} />
        ) : (
          <div className={cx("no-data-content")}>
            <h1>My Events</h1>
            <div className={cx("group")}>
              <p>
                No Event Found, Start create you're first <strong>event</strong>
              </p>
              <Link to="create-event">
                <button>Create Event</button>
              </Link>
            </div>
          </div>
        )}
        <Link to="/create-event">
          <div className={cx("fab-btn")}>
            <Plus />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Content;
